import { type ReactElement } from 'react'
import { PROGRAM_COMPLETION_OPTIONS } from '@front/model'
import { Select } from '@mantine/core'
import { ProgramDuration } from './ProgramDuration'
import { type WithProgramForm } from './type'

export const ProgramCompletionType = ({ form }: WithProgramForm): ReactElement => {
  const completion = form.values.completion

  return (
    <>
      <Select
        allowDeselect={false}
        data={PROGRAM_COMPLETION_OPTIONS}
        flex={1}
        label='Completion'
        {...form.getInputProps('completion')}
      />
      {completion === 'timeline' && <ProgramDuration form={form} />}
    </>
  )
}
